// extracted by mini-css-extract-plugin
module.exports = {"wrap":"HeadlineLoop_wrap__3PTne","loop":"HeadlineLoop_loop__2A6qT"};